<template>
  <div>
    <div 
      id="modal-estoque-rede-produto"
      class="w3-animate-zoom w3-modal" 
      v-if="abrir_modal_estoque_rede_produto" 
      style="display: block; z-index:110!important; padding:0px!important;">
      
      <div class="w3-modal-content w3-animate-zoom " @click.stop>
        <header class="w3-container">
          <span @click="abrir_modal_estoque_rede_produto = false" class="w3-button w3-display-topright">&times;</span>
          <h5 class="texto-cinza w3-center">{{formatarValor(dados_produto.produto_id, 0)}} - {{dados_produto.nome}}</h5>
        </header>

        <div>
          <div class="w3-responsive w3-hide-small w3-hide-medium" 
            style="max-height: calc(75vh - 320px);min-height: 300px;overflow: auto">

            <table class="w3-table-all">
              <thead>
                <tr>
                  <th>Empresa</th>
                  <th class="alinhamento-numero">Disponível (A)</th>
                  <th class="alinhamento-numero">Reservado (B)</th>
                  <th class="alinhamento-numero">Transferências de entregas pendentes (C)</th>
                  <th class="alinhamento-numero">Físico (A+B)</th>
                  <th class="alinhamento-numero">Entregas sem agendamento</th>
                  <th class="alinhamento-numero">Compras pendentes</th>
                  <th class="alinhamento-numero">Quantidade ponta estoque</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="estoque in produto_estoque_rede">
                  <td>{{estoque.nome_resumido_empresa}}</td>
                  <td class="alinhamento-numero w3-text-green">{{estoque.disponivel}}</td>
                  <td class="alinhamento-numero w3-text-red">{{estoque.estoque_reservado}}</td>
                  <td class="alinhamento-numero w3-text-green">{{estoque.transf_entregas_pendentes}}</td>
                  <td class="alinhamento-numero">{{estoque.estoque_fisico}}</td>
                  <td class="alinhamento-numero w3-text-red">{{estoque.entregas_sem_agendamento}}</td>
                  <td class="alinhamento-numero">{{estoque.compras_pendentes}}</td>
                  <td class="alinhamento-numero w3-text-purple">{{estoque.qtd_disponivel_ponta_estoque}}</td>
                </tr>
              </tbody>

            </table>
          </div>

          <div class="w3-hide-large">
            <div class="w3-row-padding">
              <div style="max-height: calc(80vh - 50px); min-height: 100px; overflow: auto">
                <div class="w3-center">
                  <h4 class="titulo texto-vermelho" style="margin-top:0px;">Estoque das filiais</h4>  
                </div>
                <div 
                  class="w3-card card-produto w3-animate-left w3-col s12" 
                  v-for="(estoque, index) in produto_estoque_rede" 
                  :key="index" 
                  v-cloak>
                  
                  <div class="w3-container" style="padding:10px 0px">
                    <div class="w3-center" v-if="estoque.totalizador">
                      <h4 class="titulo texto-vermelho" style="margin-top:0px;">Total geral</h4>  
                    </div>

                    <div class="w3-col s12" v-if="!estoque.totalizador">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Empresa: </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.nome_resumido_empresa}}</strong>
                    </div>
                  
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Disponível (A): </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.disponivel}}</strong>
                    </div>      
                  
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Reservado (B): </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.estoque_reservado}}</strong>
                    </div>   
                  
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Transf. de entregas pendentes (C): </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.transf_entregas_pendentes}}</strong>
                    </div>      
                
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Físico (A+B): </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.estoque_fisico}}</strong>
                    </div>    
                
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Entregas sem agendamento: </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.entregas_sem_agendamento}}</strong>
                    </div>   
                
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Compras pendentes: </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.compras_pendentes}}</strong>
                    </div>     
                
                    <div class="w3-col s12">
                      <label v-bind:class="getTotalizador(estoque.totalizador)">Quantidade ponta estoque: </label>
                      <strong v-bind:class="getTotalizador(estoque.totalizador)">{{estoque.qtd_disponivel_ponta_estoque}}</strong>
                    </div>   
                  </div>
                </div>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
    <!-- Fim modal de estoque em rede produto  -->
  </div>
</template>
<script>

import VueNumeric from 'vue-numeric'
import formatarValorMixin from '@/mixins/formatarValorMixin'
import moment from 'moment'
import Legenda from '@/components/Legendas' 
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import REstoqueBuscarEstoqueRede from '@/components/Rest/REstoque/REstoqueBuscarEstoqueRede.js'

export default {
  name: 'ModalEstoqueRedeProduto',
  components: {
    VueNumeric, Legenda
  },
  mixins:[formatarValorMixin],
  data () {
    return {
      api: process.env.API,
      dados_produto: {},
      abrir_modal_estoque_rede_produto: false,
      produto_estoque_rede: [],
    }
  },
  methods: {
    exibirModal(produto){
      console.log(produto)
      this.dados_produto = Object.assign({}, produto);
      this.buscarProdutoEstoqueRede();
      this.abrir_modal_estoque_rede_produto = true;
    },

    async buscarProdutoEstoqueRede(){
      try {
        
        let parametros = {
          produto_id: this.dados_produto.produto_id
        }

        let retorno = await REstoqueBuscarEstoqueRede.buscarEstoqueRede(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        let totalizador = {};
        this.produto_estoque_rede = retorno.dados;

        totalizador.totalizador = true;
        totalizador.disponivel = 0;
        totalizador.transf_entregas_pendentes = 0;
        totalizador.estoque_fisico = 0;
        totalizador.estoque_reservado = 0;
        totalizador.entregas_sem_agendamento = 0;
        totalizador.compras_pendentes = 0;
        totalizador.qtd_disponivel_ponta_estoque = 0;
        totalizador.entregas_sem_agendamento = 0;

        for (let i = 0; i < this.produto_estoque_rede.length; i++) {
          this.produto_estoque_rede[i].totalizador = false;
          totalizador.disponivel += Biblioteca.valor(this.produto_estoque_rede[i].disponivel);
          totalizador.transf_entregas_pendentes += Biblioteca.valor(this.produto_estoque_rede[i].transf_entregas_pendentes);
          totalizador.estoque_fisico += Biblioteca.valor(this.produto_estoque_rede[i].estoque_fisico);
          totalizador.estoque_reservado += Biblioteca.valor(this.produto_estoque_rede[i].estoque_reservado);
          totalizador.compras_pendentes += Biblioteca.valor(this.produto_estoque_rede[i].compras_pendentes);
          totalizador.qtd_disponivel_ponta_estoque += Biblioteca.valor(this.produto_estoque_rede[i].qtd_disponivel_ponta_estoque);
          totalizador.entregas_sem_agendamento += Biblioteca.valor(this.produto_estoque_rede[i].entregas_sem_agendamento);
        }

        totalizador.disponivel = this.formatarValor(totalizador.disponivel);
        totalizador.transf_entregas_pendentes =  this.formatarValor(totalizador.transf_entregas_pendentes);
        totalizador.estoque_fisico = this.formatarValor(totalizador.estoque_fisico);
        totalizador.estoque_reservado = this.formatarValor(totalizador.estoque_reservado);
        totalizador.entregas_sem_agendamento = this.formatarValor(totalizador.entregas_sem_agendamento);
        totalizador.compras_pendentes = this.formatarValor(totalizador.compras_pendentes);
        totalizador.qtd_disponivel_ponta_estoque = this.formatarValor(totalizador.qtd_disponivel_ponta_estoque);
        
	      this.produto_estoque_rede.push(totalizador);    
      } catch (error) {
        this.verificarErro(error, 'buscarProdutoEstoqueRede');
      }
    },

    verificarErro(erro, nome_funcao){
      Biblioteca.gerarLogNomeFuncao('ModalCaracteristicasProduto.vue -> ' + nome_funcao);
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },

    getTotalizador(totalizador){
      if (totalizador){
        return 'texto-totalizador';
      }else{
        return 'texto-padrao';
      }
    }
    
  },
}
</script>
<style>
  .tela-cheia{
    width: 100%!important;
    height: 100%!important;
    padding-top: 0%!important;
    padding-left: 0%!important;
  }
  .texto {
    margin:0; 
    padding:0; 
    font-size:12px; 
    font-weight:bold;
  }
  .texto-totalizador{
    color: #2b2b2b;
  }
  .texto-padrao{
    color: #2b2b2b;
  }
</style>



// WEBPACK FOOTER //
// src/components/Orcamentos/ModalEstoqueRedeProduto.vue